/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react'
import DynamicDeliveries from './DeliveriesDynamic'

const Deliveries: React.FunctionComponent = () => {
    return (
        <div>
            <div className='flex justify-between mb-4 items-center'>
                <h2>Opleveringen</h2>
            </div>
            <div className='border-full shadow-sm bg-white rounded-xl'>
                <div className='relative min-h-[500px] flex flex-col'>
                    <DynamicDeliveries canSearch />
                </div>
            </div>
        </div>
    )
}

export default Deliveries
